import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as jsbarcode from 'jsbarcode';
import { Subject, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'daas-consulting-shared-bar-code',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bar-code.component.html',
  styleUrl: './bar-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarCodeComponent implements OnChanges {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLImageElement>;
  @Input() value!: string;
  @Output() rendered = new EventEmitter();

  readonly #barCodeSubject$ = new Subject<string>();
  readonly #destroyRef = inject(DestroyRef);

  constructor() {
    this.#barCodeSubject$
      .pipe(takeUntilDestroyed(this.#destroyRef), distinctUntilChanged())
      .subscribe((value) => {
        this._render(value);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('value' in changes) {
      const value = changes['value'].currentValue;
      this.#barCodeSubject$.next(value);
    }
  }

  private _render(value: string): void {
    jsbarcode(this.canvas.nativeElement, value, {
      format: 'CODE39',
      displayValue: false,
    });
    this.rendered.emit();
  }
}
